exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.attributes-table {\n  background-color: rgba(255, 255, 255, 0.85);\n  /* display: -webkit-flex; */\n  display: flex;\n  /* -webkit-flex: 1; */\n  flex: 1;\n  /* -webkit-flex-direction: column; */\n  flex-direction: column;\n  /*-webkit-align-items: stretch;\n  align-items: stretch;\n}\n.attributes-table h3 {\n  /* -webkit-align-self: center;\n  align-self: center; */\n}\n", ""]);

// exports
